import inRange from "lodash/inRange";
import { TimeFormat } from "../../enum";
import { FormFieldOption } from "shared/form/fields/types";

const TIME_JOINED_BY = ":";
export const MAX_HOUR_12_HOUR_FORMAT = 12;
export const MAX_MINUTE = 60;
export const MAX_SECOND = 60;

export function padNumberByTwoDigit(value: number) {
  return value.toString().padStart(2, "0");
}

/**
 * Parse Hour, Minute from time string
 */
export function parseTimeString(time: string) {
  const [hour, minute] = time.split(TIME_JOINED_BY);
  return [parseToNumber(hour), parseToNumber(minute)];
}
/**
 * Returns time string (hh:mm) from hour and minute
 */
export function toTimeString(hour: number, minute: number) {
  return [padNumberByTwoDigit(hour), padNumberByTwoDigit(minute)].join(TIME_JOINED_BY);
}

export function parseMinute(minute: string) {
  let minuteNumber = parseToNumber(minute);
  return inRange(minuteNumber, 0, MAX_MINUTE) ? minuteNumber : 0;
}

export function parseSecond(second: string) {
  let secondNumber = parseToNumber(second);
  return inRange(secondNumber, 0, MAX_SECOND) ? secondNumber : 0;
}

export function getDefaultTimeFormat(value: number) {
  return value < MAX_HOUR_12_HOUR_FORMAT ? TimeFormat.AM : TimeFormat.PM;
}

function parseToNumber(value: string) {
  const parsedNumber = parseInt(value);
  return isNaN(parsedNumber) ? 0 : parsedNumber;
}

/**
 * transform hour from display value to 24 hour value
 */
export function transformHourForApi(value: string, timeFormat: TimeFormat) {
  let realHourValue = parseToNumber(value);
  // AM value goes as it is except 12 AM should go as 0
  if (timeFormat === TimeFormat.AM && realHourValue >= 12) {
    realHourValue = 0;
  } else if (timeFormat === TimeFormat.PM) {
    if (realHourValue >= 12) {
      // 12 in PM will change the date and we don't want that: reset it to 12 PM
      realHourValue = 12;
    } else {
      // add 12 in hour value since its PM
      realHourValue = realHourValue + 12;
    }
  }
  return realHourValue;
}

/**
 * transform 24 hour value to display value in AM/PM
 */
export function transformHourTo12HourFormat(value: number) {
  // 0 or 12 should be 12 AM and 12 PM respectively
  if (value === 0 || value === 12) {
    return 12;
  }
  // anything between 0 and 12 print as it is
  if (inRange(value, 0, 12)) {
    return value;
  }
  // more than 12: print Remainder
  return value % 12;
}

export function getNumberRangeAsOptions(min: number, max: number): Array<FormFieldOption> {
  return Array.from(Array(max - min + 1), (_, index) => ({
    label: padNumberByTwoDigit(min + index),
    value: (min + index).toString()
  }));
}
